import { Component } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { CommonService } from '../shared/services/common.service';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatModule } from '../appModules/mat.module';

@Component({
  selector: 'app-years',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatLabel,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule
  ],
  templateUrl: './years.component.html',
  styleUrl: './years.component.scss'
})
export class YearsComponent {
  years:any;
  currentPage=0;
  formGroup:FormGroup
  is_list_visible: boolean = true
  add_form: boolean = false

  displayedColumns: string[] = [
    'actions','sno','year_name','is_active'
  ];

  constructor(private api: ApiService, private common: CommonService, private fb:FormBuilder) { 
    this.formGroup = this.fb.group({
      year_name: ['', [Validators.required]],
    });
  }
  ngOnInit(){
    this.year_list_in_listAll();
  }

  // year_list() {
  //   this.api.get('settings/year_list').subscribe({
  //     next: (resp) => {
  //       if (resp.success) {
  //         this.years = resp.data
  //         console.log('Year list fetched', resp.data);
  //       }
  //     },
  //     error: (err) => {
  //       console.error('Error fetching year list:', err);
  //     }
  //   });
  // }
  

  year_list_in_listAll() {
    this.api.get('settings/year_list_in_admin').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.years = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  change_status(year: any) {
    const payload = {
      id: year
    }
    this.api.post('settings/toggle_year_status',payload, true).subscribe({
      next: (resp) => {
        if (resp.success) {
          console.log('Status changed:', resp.data);
          this.year_list_in_listAll(); 
        }
      },
      error: (err) => {
        console.error('Status update failed', err);
      }
    });
  }

  add_year(){
    const payload ={
      year_name: this.formGroup.get('year_name')?.value || ''
    }
    this.api.post('settings/add_year',payload, true).subscribe(resp =>{
      if(resp.success){
        this.add_form = false
        this.is_list_visible = true
        this.year_list_in_listAll();
      }
    })
  }

  adding_year(){
    this.is_list_visible = false
    this.add_form = true;
  }

  resetForm(): void {
    this.is_list_visible = true;
    this.formGroup.reset();
   
  }

  back(){
    this.add_form =false;
    this.is_list_visible = true;  
    this.resetForm();
    this.year_list_in_listAll();
   }

}
